/**
 * 会议翻译模块路由配置
 * - 主讲人页：需要认证 + speech_translation 权限
 * - 观众页：不需认证
 */
import type { RouteRecordRaw } from 'vue-router'
import { Permission } from '@/utils/permission'
import {
  SpeechTranslationView,
  SpeechTranslationHistoryView,
  TranslationRecordView
} from '@/modules/speech-translation/views'
import RouteOutlet from '@/components/layout/RouteOutlet.vue'

// 观众页路由（不需认证，需放在顶层，无布局）
export const translationRecordRoute: RouteRecordRaw = {
  path: '/translation-record/:userCode',
  name: 'TranslationRecord',
  component: TranslationRecordView,
  props: true,
  meta: {
    title: '翻译中',
    requiresAuth: false,
    hidden: true
  }
}

// 主讲人页（布局内）
const speechTranslationRoutes: RouteRecordRaw[] = [
  {
    path: 'speech-translation',
    name: 'SpeechTranslationRoot',
    component: RouteOutlet,
    redirect: { name: 'SpeechTranslation' },
    meta: {
      titleKey: 'menu.speechTranslation',
      title: '会议翻译',
      requiresAuth: true,
      // 具备 use 或 view 任一权限即可在菜单中看到「会议翻译」分组
      permissions: [Permission.SPEECH_TRANSLATION_USE, Permission.SPEECH_TRANSLATION_VIEW],
      icon: 'SoundOutlined',
      breadcrumb: true
    },
    children: [
      {
        path: '',
        name: 'SpeechTranslation',
        component: SpeechTranslationView,
        meta: {
          titleKey: 'menu.speechTranslation',
          title: '会议翻译',
          requiresAuth: true,
          permissions: [Permission.SPEECH_TRANSLATION_USE],
          breadcrumb: true
        }
      },
      {
        path: 'history',
        name: 'SpeechTranslationHistory',
        component: SpeechTranslationHistoryView,
        meta: {
          titleKey: 'menu.translationHistory',
          title: '翻译历史',
          requiresAuth: true,
          permissions: [Permission.SPEECH_TRANSLATION_VIEW],
          breadcrumb: true
        }
      }
    ]
  }
]

export default speechTranslationRoutes
